import React, { useState } from 'react'
import { Grid } from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import { usePeopleMergeContext } from 'pages/MergeProfiles/contexts/PeopleMergeContext'
import PlatformJobsList from './PlatformJobsList'
import FactSetJobsList from './FactSetJobsList'
import JobMapDrawer from './JobMapDrawer'
import JobMappedPreviewDrawer from './JobMappedPreviewDrawer'

/**
 * MultipleJobsSection - Main container for the job mapping interface (Step 2)
 * This is the main section where users create job mappings between source (Platform) and target (FactSet) profiles. It orchestrates the job mapping workflow.
 * @returns {React.Component} The complete job mapping interface with lists and drawers
 */
const MultipleJobsSection = () => {
  const { mergeData, jobMappingData } = usePeopleMergeContext()
  const { sourcePerson, targetPerson } = mergeData
  const { selectedPlatformJobs } = jobMappingData

  const [isMapDrawerOpen, setIsMapDrawerOpen] = useState(false)
  const [isPreviewDrawerOpen, setIsPreviewDrawerOpen] = useState(false)
  const [selectedTargetJobId, setSelectedTargetJobId] = useState(null)
  const [selectedJobs, setSelectedJobs] = useState(null)

  const hasSelectedJobs = selectedPlatformJobs.length > 0

  const handleOpenMapDrawer = () => {
    setSelectedJobs(null)
    setIsMapDrawerOpen(true)
  }

  const handleCloseMapDrawer = () => {
    setIsMapDrawerOpen(false)
    setSelectedJobs(null)
  }

  const handleOpenPreviewDrawer = targetJobId => {
    setSelectedTargetJobId(targetJobId)
    setIsPreviewDrawerOpen(true)
  }

  const handleClosePreviewDrawer = () => {
    setIsPreviewDrawerOpen(false)
    setSelectedTargetJobId(null)
  }

  const handleEditMapping = (sourceJobIds, targetJobId) => {
    setSelectedJobs({ sourceJobIds, targetJobId })
    setIsPreviewDrawerOpen(false)
    setIsMapDrawerOpen(true)
  }

  if (!sourcePerson || !targetPerson) {
    return null
  }

  return (
    <Grid item container>
      <Grid item container spacing={2} alignItems="stretch">
        <Grid item xs={5}>
          <PlatformJobsList />
        </Grid>

        <Grid
          item
          xs={2}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            disabled={!hasSelectedJobs}
            onClick={handleOpenMapDrawer}
          >
            Map
          </Button>
        </Grid>

        <Grid item xs={5}>
          <FactSetJobsList openJobMappingPreview={handleOpenPreviewDrawer} />
        </Grid>
      </Grid>

      <JobMapDrawer
        open={isMapDrawerOpen}
        onClose={handleCloseMapDrawer}
        selectedJobs={selectedJobs}
      />

      <JobMappedPreviewDrawer
        open={isPreviewDrawerOpen}
        onClose={handleClosePreviewDrawer}
        selectedTargetJobId={selectedTargetJobId}
        onEdit={handleEditMapping}
      />
    </Grid>
  )
}

export default MultipleJobsSection
